<template>
  <button type="button" class="btn btn-link text-danger" click.delegate="clear()" if.bind="canClear">
    <i class="fas fa-times"></i> Clear Filters
  </button>
</template>
